class SubscribeOption extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.selling_plan_inputs = document.querySelectorAll("input[selling-plan-input]");
    this.planVariants = document.querySelectorAll(".option_variant--plan");
    this.otVariants = document.querySelectorAll(".option_variant--ot");
    this.atcButton = document.querySelector(".product-form__submit");
    if (this.querySelector(`select[name="selling_plan"]`)) {
      this.frequency = this.querySelector(`select[name="selling_plan"]`);
      let freqMinimumQty = this.frequency.options[this.frequency.selectedIndex].getAttribute("data-minimum-qty");
      this.minQuantityToAdd = parseInt(freqMinimumQty);
      this.updatedDiscountPrice = parseInt(this.frequency.options[this.frequency.selectedIndex].getAttribute("data-price"));
      this.updatedDiscountPercentage = parseInt(this.frequency.options[this.frequency.selectedIndex].getAttribute("data-percentage"));
      this.updatedDiscountSupply = this.frequency.options[this.frequency.selectedIndex].getAttribute("data-supply");
    }
  }

  connectedCallback() {
    this.handleSuscription();
    this.input.addEventListener("change", (e) => {
      this.handleSuscription();
    });

    if (this.frequency) {
      this.frequency.addEventListener("change", (e) => {
        const freq_value = e.target.value;
        this.selling_plan_inputs.forEach((input) => {
          input.value = freq_value;
        });
        this.minQuantityToAdd = parseInt(this.frequency.options[this.frequency.selectedIndex].getAttribute("data-minimum-qty"));
        this.updatedDiscountPrice = parseInt(this.frequency.options[this.frequency.selectedIndex].getAttribute("data-price"));
        this.updatedDiscountPercentage = parseInt(this.frequency.options[this.frequency.selectedIndex].getAttribute("data-percentage"));
        this.updatedDiscountSupply = this.frequency.options[this.frequency.selectedIndex].getAttribute("data-supply");
        this.handlingFrequencyInfo();
      });
    }
  }
  handleSuscription() {
    if (this.input.checked) {
      if (this.input.value == "subscribe") {
        this.selling_plan_inputs.forEach((input) => {
          input.removeAttribute("disabled");
        });
        this.handlingFrequencyInfo();
        this.toggleVariant(this.planVariants);
      } else {
        this.selling_plan_inputs.forEach((input) => {
          input.setAttribute("disabled", "");
        });
        this.atcButton.innerHTML = `Add to Cart - ${Shopify.formatMoney(
          parseInt(this.querySelector("[data-otp-price]").dataset.otpPrice),
          Shopify.money_format
        )}`;
        this.toggleVariant(this.otVariants);
      }
    }
  }
  toggleVariant(activeVariants) {
    let enable = this.planVariants,
      disable = this.otVariants;
    activeVariants != this.planVariants && ((enable = this.otVariants), (disable = this.planVariants));
    disable.forEach((variant) => {
      variant.style.display = "none";
      variant.querySelectorAll("input").forEach((input) => input.setAttribute("disabled", ""));
    });
    enable.forEach((variant) => {
      variant.style.display = "block";
      variant.querySelectorAll("input").forEach((input) => input.removeAttribute("disabled"));
    });
  }

  handlingFrequencyInfo() {
    let originalPrice = this.querySelector(`[data-subscription-original-price]`);
    let discountedPrice = this.querySelector(`[data-subscription-discounted-price]`);
    let badge = this.querySelector(`[data-badge]`);
    let originalPriceValue = parseInt(originalPrice.getAttribute("data-value"));
    let discountedPriceValue = this.updatedDiscountPrice;
    let usps = this.querySelector(".option-box__usps");
    let productPrice = document.querySelector(".price--show-badge .price__regular .price-item--regular");

    let originalPriceFormated = Shopify.formatMoney(originalPriceValue * this.minQuantityToAdd, Shopify.money_format);
    let discountedPriceFormated = Shopify.formatMoney(discountedPriceValue * this.minQuantityToAdd, Shopify.money_format);
    let supply = Shopify.formatMoney(this.handlingPaymentDays(this.updatedDiscountSupply, discountedPriceValue), Shopify.money_format);

    let discountStrongs = usps.querySelectorAll("ul li strong");
    if (discountStrongs.length > 0) {
      discountStrongs.forEach((strong) => {
        if (strong.innerText.trim() === "8% OFF" || strong.innerText.trim() === "10% OFF") {
          strong.innerText = `${this.updatedDiscountPercentage}% OFF `;
        }
      });
    }

    originalPrice.innerText = originalPriceFormated;
    discountedPrice.innerText = discountedPriceFormated;
    productPrice.innerHTML = ` ${discountedPriceFormated} <span class="atc-compare-price caption">${originalPriceFormated}</span>`;
    badge.innerText = this.updatedDiscountPercentage;
    this.atcButton.innerHTML = `Add to Cart - ${discountedPriceFormated}  <span class="atc-compare-price caption">${originalPriceFormated}</span>`;
  }
  handlingPaymentDays(months, price) {
    switch (months) {
      case "month":
        return price / 30;
      case "2 months":
        return price / (30 * 2);
      case "6 months":
        return price / (30 * 6);
      case "8 months":
        return price / (30 * 8);
      default:
        return price / 30;
    }
  }
}

customElements.define("subscribe-option", SubscribeOption);
